import React from 'react';
import logo from './logo.svg';
import './App.css';
import Sorting from './Sorting/Sorting';

function App() {
  return (
    <div className="App">
    <Sorting></Sorting>
    </div>
  );
}

export default App;
